import React, { useCallback, useState, useEffect } from "react";

export const useDetectOnline = () => {
  const [isOffline, setIsOffline] = useState(false);

  useEffect(() => {
    const handleOnline = () => setIsOffline(false);
    const handleOffline = () => setIsOffline(true);

    setIsOffline(!window.navigator.onLine);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const runIfOnline = useCallback(
    ({
      onNowOnline,
      onNowOffline,
    }: {
      onNowOnline: () => void;
      onNowOffline: () => void;
    }) => {
      if (window.navigator.onLine) {
        onNowOnline();
      } else {
        onNowOffline();
        window.addEventListener("online", onNowOnline, { once: true });
      }
    },
    []
  );

  return { isOffline, runIfOnline };
};
